
import {filter, combineLatest} from 'rxjs/operators';
import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { SuitabilityProfileModel } from "@toro/common/shared/models/suitability/suitabilityProfile.model";
import { SuitabilityAction } from "@toro/common/shared/state-management/suitability/suitability.action";
import { TrackingActions } from "@toro/common/shared/state-management/tracking/tracking.action";
import { Observable } from "rxjs";
import { SuitabilityProfilesEnum } from "@toro/common/shared/enum/suitability/suitability-profiles.enum";
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: "thank-you-page",
    templateUrl: "./thank-you-page.component.html",
    styleUrls: ["./thank-you-page.component.scss"],
    providers: [],
})
export class ThankYouPageComponent implements OnInit {
    public isNewBrand = environment.isNewBrand

    public user$: Observable<any>;
    public user: any;
    public suitabilityDefined: boolean = false;
    public suitability: SuitabilityProfileModel = new SuitabilityProfileModel();

    constructor(private store: Store<any>) {
        this.store.dispatch({ type: SuitabilityAction.getProfile });
    }

    public ngOnInit() {
        this.sendTracking("Page Loaded", {
            'Time Responsável': "Brooklyn Dumbo",
            'Status': "Conta em validação",
            'Product Area Origin': 'Validação trader',
            path: "/thank-you-page",
        });
        this.store
            .select(({ userProfile }) => userProfile.user).pipe(
            combineLatest(this.store.select(({ suitability }) => suitability)),
            filter(
                ([{ profile }, suitability]) =>
                    !!profile && !!suitability.profile
            ),)
            .subscribe(([user, { profile }]) => {
                this.user = user;
                this.suitability.profile = profile.profile;
            });

    }

    public getSuitabilityName() {
        switch (this.suitability.profile) {
            case SuitabilityProfilesEnum.Conservative:
                return "Conservador";
            case SuitabilityProfilesEnum.Moderate:
                return "Moderado";
            case SuitabilityProfilesEnum.Bold:
                return "Arrojado";
        }
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public setProfile() {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': 'Validação trader',
            'Time Responsável': "Brooklyn Dumbo",
            Element: "Botão definir perfil",
            Scenario: this.suitability.profile === 1 ? 'Definir perfil' : this.getSuitabilityName(),
            path: "/thank-you-page",
        });
        window.location.href = "/perfil";
    }
}
